import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const WelcomeHeaderControlPanelStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const WelcomeHeaderLangChooserContainerStyled = styled.div`
    display: flex;
    align-items: center;
    margin-left: 32px;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-left: 16px;
    }
`;
